import { useAuth } from '../../contexts/AuthContext'
import { useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, login } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Verification de l'authentification...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    login(location.pathname)
    return null
  }

  return <>{children}</>
}
